/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

// import {
//   IAgentPlugin,
//   IPluginMethodMap,
// } from '@vlinder-web/plugin-agent-service-react';
// import { config } from '../../config/featuresSection.config';
// export interface IFeatureActualDetailPluginMethods extends IPluginMethodMap {
//   getFeatureActualDetailSync(args?: any): any;
// }

// export class FeatureActualDetailPlugin implements IAgentPlugin {
//   readonly methods: IFeatureActualDetailPluginMethods;

//   constructor() {
//     this.methods = {
//       getFeatureActualDetailSync: this.getFeatureActualDetailSync.bind(this),
//     };
//   }

//   getFeatureActualDetailSync(args?: any) {
//     return {
//       feature:config
//     };
//   }
// }

/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../../config/featuresSection.config.json';
import { GET_POLICY_DETAIL } from '@pages/ActualDetailPage/api/graphql';
import { usePolicyId } from '../../provider';
import { Graphql } from '@common/graphql';
import { apiConfig } from '@/config/apiConfig';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator/services';
import { themeConfig } from '@/providers/theme';

import { toHeaderCase } from 'js-convert-case';
import moment from 'moment';

const lookup = require('country-code-lookup');

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IFeatureActualDetailPluginMethods extends IPluginMethodMap {
  getFeatureActualDetail(): Promise<any>;
}

export class FeatureActualDetailPlugin implements IAgentPlugin {
  readonly methods: IFeatureActualDetailPluginMethods;

  constructor() {
    this.methods = {
      getFeatureActualDetail: this.getProps.bind(this),
    };
  }

  async getProps() {
    return await this.getFeatureActualDetail();
  }

  private async getFeatureActualDetail() {
    const { policyNumber, userVid } = usePolicyId();
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      // const token = getToken();
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      const res = await client.query(GET_POLICY_DETAIL, {
        input: {
          policyId: policyNumber,
        },
        input1: {
          limit: 100,
          where: [
            {
              column: 'txnOwner',
              op: 'Equal',
              value: [userVid],
            },
            {
              column: 'type',
              op: 'In',
              value: ['POLICY_PURCHASE_FLOW', 'KYC_SUBMISSION'],
            },
            {
              column: 'txnSetId',
              op: 'In',
              value: [policyNumber, null],
            },
          ],
        },
      });
      if (res?.data) {
        console.log(`policy details`, res?.data?.getPolicyDetail);
        let _result = res?.data?.getPolicyDetail;
        let _txtResult = res?.data?.getTxnList?.data;
        return {
          title: _result?.policyNumber,
          subTitle: _result?.policyNumber,
          statusComp: _result?.status
            ? {
                title: `Current status: ${toHeaderCase(_result?.status)}`,
                statusType: 'success',
              }
            : null,
          listItems: this.getListItems(_result),
          // beneficiaryDetails: this.getBeneficiary(_result?.Nominee),
          policyDocument: `data:application/pdf;base64,${_result?.pdf}`,
          accordionItems: this.getAccordionItems(_result, _txtResult),
          policyDetails: this.getPolicyDetails(_result),
          carouselItems: this.getCarouselItems(_result),
          // useOfProceedDetails: this.getUseOfProceeds(_result),
          buttons: this.getButtons(_result),
          timelineData: res?.data?.getTxnList,
        };
      }
    } catch (err: any) {}
  }
  private getAccordionItems(res: any, txList: any) {
    let items: any = [];
    let _policyHolder = this.getPolicyDetails(res);
    if (res?.description) {
      items.push({
        type: 'text',
        title: 'Description',
        data: [res?.description],
      });
    }
    if (_policyHolder) {
      items?.push({
        type: 'multi-col-list',
        numberOfLines: '3',
        title: _policyHolder?.title,
        data: [..._policyHolder?.listItems],
      });
    }
    if (res?.purchasedBy) {
      let _holder = this.getPolicyHolder(res?.purchasedBy);
      if (_holder) {
        items?.push({
          type: 'multi-col-list',
          numberOfColumns: '3',
          title: _holder?.title,
          data: [..._holder?.listItems],
        });
      }
    }

    if (res?.nominee) {
      let _temp = this.getBeneficiary(res?.nominee);
      items.push({
        type: 'multi-col-list',
        numberOfLines: '3',
        title: _temp?.title,
        data: [..._temp?.listItems],
      });
    }

    if (txList?.length > 0) {
      let timelineDetails = this.getTimeLine(txList);
      items.push({
        type: 'timeline',
        title: config?.timelineDetails?.title,
        data: [...timelineDetails],
        lineColor: themeConfig?.colors?.orangePrimary,
        horizontalStepperColors: {
          DONE: themeConfig?.colors?.orangeSecondary,
          UNDONE: themeConfig?.colors?.orangeSecondary,
          LAST: themeConfig?.colors?.orangeSecondary,
          CURRENT: themeConfig?.colors?.orangeSecondary,
        },
      });
    }

    // let _useOfProceeds = this.getUseOfProceeds(res);
    // if(_useOfProceeds){
    //   items.push({
    //     type:"check-list",
    //     title:_useOfProceeds?.title,
    //     data:[..._useOfProceeds?.listItems]
    //   })
    // }

    return items;
  }

  private getCarouselItems(data: any) {
    let _temp = [];
    let _kyc = [];
    if (data?.pdf) {
      _temp.push({
        type: 'pdf',
        poster: `data:application/pdf;base64,${data?.pdf}`,
        src: `data:application/pdf;base64,${data?.pdf}`,
        title: 'Policy Contract',
      });
    }
    if (Array.isArray(data?.kycDoc)) {
      _kyc = data?.kycDoc.map((element: any) => {
        return {
          ...element,
          type: this.getDocType(element?.fileType),
          src: element?.doc,
          title: element?.name,
          poster: element?.poster,
        };
      });
    }

    return [..._temp, ..._kyc];
  }

  private getDocType(res: any) {
    switch (res) {
      case 'application/pdf':
        return 'pdf';
      case 'image/png':
        return 'img';
      case 'image/jpg':
        return 'img';
      case 'image/jpeg':
        return 'img';
      default:
        return null;
    }
  }

  private getPolicyHolder(data: any) {
    let _temp = [];
    _temp = config?.policyHolder?.map((ele) => {
      if (ele?.key === 'address') {
        return {
          ...ele,
          subTitle: `${data[ele?.key]?.addressLine1}, ${
            data[ele?.key]?.city
          }, ${
            data[ele?.key]?.country && data[ele?.key]?.country.length === 2
              ? lookup.byIso(`${data[ele?.key]?.country}`)?.country
              : '-'
          }`,
        };
      } else if (ele?.key === 'firstName' || ele?.key === 'lastName') {
        return {
          ...ele,
          subTitle: toHeaderCase(data[ele?.key] ?? '-'),
        };
      } else
        return {
          ...ele,
          subTitle: data[ele?.key],
        };
    });
    return {
      title: config?.purchaser?.title,
      listItems: _temp,
    };
  }

  private getBeneficiary(res: any) {
    let _beneficiary = {
      firstName: res?.firstName,
      lastName: res?.lastName,
      email: res?.email,
      phoneNumber: res?.mobileNo,
      streetAddress: res?.address?.addressLine1,
      city: res?.address?.city,
      country: res?.address?.country,
    };
    let _temp = [];
    for (const [key, value] of Object.entries(_beneficiary)) {
      _temp.push({
        title: toHeaderCase(key),
        subTitle: value,
      });
    }
    return {
      title: config?.beneficiaryDetails?.title,
      listItems: _temp,
    };
  }
  private getPolicyDetails(res: any) {
    let _temp = [
      {
        title: 'Policy Number',
        subTitle: res?.policyNumber,
      },
      {
        title: 'Policy Option',
        subTitle: `Policy Option ${res?.policyOption}`,
      },
      {
        title: 'Coverage Amount',
        subTitle: res?.coverage,
      },
      {
        title: 'Annual Premium',
        subTitle: res?.premium,
      },
      {
        title: 'Purchase on',
        subTitle: moment(res?.purchasedAt).format('DD/MM/YYYY'),
      },
      {
        title: 'Policy Type',
        subTitle: toHeaderCase(res?.type ?? '-'),
      },
    ];
    return {
      title: config?.policyDetails?.title,
      listItems: _temp,
    };
  }
  private getListItems(res: any) {
    let _temp = config?.listItems?.map((ele: any) => {
      if (ele?.key === 'policyName') {
        return {
          ...ele,
          subTitle: `Policy Option ${res?.policyOption}`,
        };
      }
      if (ele?.key === 'coverage') {
        return {
          ...ele,
          subTitle: res?.coverage,
        };
      }
      if (ele?.key === 'premium') {
        return {
          ...ele,
          subTitle: res?.premium,
        };
      }
    });
    return _temp;
  }

  private getUseOfProceeds(data: any) {
    let _temp: any = [];
    Array.isArray(data?.useOfProceeds) &&
      data?.useOfProceeds?.forEach((element: any) => {
        if (element.selected) {
          _temp.push(toHeaderCase(element?.value ?? ''));
        }
      });

    return {
      title: config?.useOfProceedsDetail?.title,
      listItems: _temp,
    };
  }

  private getButtons(result: any) {
    let _tempButton: any = [];
    _tempButton.push(config?.buttons);
    _tempButton.push(config?.tropicalCycloneButton);
    if (result?.blockchainTxnURL) {
      _tempButton.push({
        ...config?.viewTransactionButton,
        link: result?.blockchainTxnURL,
      });
    }
    return _tempButton;
  }

  private getTimeLine(data: any) {
    let _temp: any = [];
    Array.isArray(data) &&
      data?.forEach((element) => {
        _temp.push({
          key: element?.id,
          headline: toHeaderCase(element?.action ?? ''),
          headlineBackgroundColor: themeConfig?.colors?.orangePrimary,
          children: this.getChildren(element),
        });
      });

    return _temp;
  }

  private getChildren(data: any) {
    let _temp: any = [];
    _temp.push({
      itemId: data?.id,
      multiColList: this.getProvenanceAccordion(data),
      title: toHeaderCase(data?.action ?? ''),
      subtitle: data?.when ? moment(parseInt(data?.when)).format('LLL') : null,
    });

    return _temp;
  }

  private getProvenanceAccordion(res: any) {
    let _temp: any = [];
    if (res) {
      let _list: any = [];
      let _date: any = [];
      let _location: any = [];
      if (res?.performedBy?.firstName) {
        _list.push({
          title: toHeaderCase('by'),
          subTitle: `${toHeaderCase(
            res?.performedBy?.firstName
          )} ${toHeaderCase(res?.performedBy?.lastName)}`,
          icon: config?.orgIcon,
        });
      }
      if (res?.location) {
        _location.push({
          title: toHeaderCase('at'),
          subTitle: res?.location ?? '-',
          icon: config?.locationIcon,
        });
      }
      if (res?.when) {
        _date.push({
          title: toHeaderCase('on'),
          subTitle: res?.when ? moment(parseInt(res?.when)).format('LLL') : '-',
          icon: config?.dateIcon,
        });
      }
      _temp = [..._list, ..._location, ..._date];
    }
    return {
      numberOfColumns: '2',
      data: _temp,
    };
  }
}
